import { REPORTS_NAMESPACE_TRANSLATIONS } from "./reports-namespace-translations.ts"
import { REPORTS_TRANSLATIONS } from "./reports-translations.ts"
import { COW_STATUS_TRANSLATIONS } from "@/locales/es/cow-status-translations.ts"
import { ES_MAIN_TRANSLATIONS } from "@/locales/es/main-translations.ts"

export const ES_TRANSLATIONS = {
  translation: {
    ...ES_MAIN_TRANSLATIONS,
    ...REPORTS_TRANSLATIONS,
  },
  cowStatus: {
    ...COW_STATUS_TRANSLATIONS,
  },
  reports: { ...REPORTS_NAMESPACE_TRANSLATIONS },
}
